<template>
  <TwoColPageWrapper :breadcrumbs="breadcrumbs" leftBanner>
    <h1>Статьи</h1>

    <div class="news-teaser-wrapper">
      <div
        class="news-teaser"
        v-for="(article, index) in articles.items"
        :key="index"
      >
        <span itemprop="datePublished">{{ article.date }}</span
        ><br />

        <router-link :to="{ name: 'article', params: { id: article.id } }">{{
          article.title
        }}</router-link>
      </div>
    </div>

    <!-- <div class="site-navigation">
      <div class="pagination">
        <span class="forum-page-first forum-page-current">1</span>
        <a href="index.html%3FPAGEN_1=2.html" class="">2</a>
        <a class="forum-page-next" href="index.html%3FPAGEN_1=2.html"></a>
      </div>
      <div class="showed-items">Показано 3 из {{ articles.total }}</div>
    </div> -->
  </TwoColPageWrapper>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      breadcrumbs: [
        {
          label: "Главная",
          to: { name: "main" },
        },
        {
          label: "Статьи",
        },
      ],
    };
  },
  computed: mapState(["articles"]),
};
</script>

<style lang="scss" scoped>
.news-teaser-wrapper {
  border-bottom: none;
}
</style>
